import { CheckIcon } from "@heroicons/react/solid";

export default function Success({ title, msg }) {
  return (
    <div className="my-2 rounded-md bg-emerald-50 dark:bg-emerald-100 p-4 mb-2">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <CheckIcon className="h-5 w-5 text-emerald-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-emerald-800">{title}</h3>
          {msg ? <div className="mt-2 text-sm text-emerald-700">{msg}</div> : null}
        </div>
      </div>
    </div>
  );
}
